import React, { useEffect, useState } from "react";
import {
    Popper,
    Paper,
    Typography,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Avatar,
    Box,
    useTheme,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { startNotificationConnection, stopNotificationConnection } from "services/notificationService";
import { useGetNotificationsQuery, useViewNotificationMutation } from "store/slices/apis/notificationSlice"
import moment from "moment";
import { useAuth } from "context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function Notifications({ open, anchorEl, notifications, setNotifications, setOpenNotification }) {
    const theme = useTheme();
    const navigate = useNavigate();
    const { user } = useAuth();
    const [markNotificationViewed] = useViewNotificationMutation();
    const { data } = useGetNotificationsQuery(user?.id, {
        skip: !user?.id,
    });

    const encrypt = (text) => btoa(unescape(encodeURIComponent(text)));

    useEffect(() => {
        if (data && Array.isArray(data)) {
            setNotifications(data);
        }
    }, [data, setNotifications]);


    useEffect(() => {
        startNotificationConnection(
            (notification) => {
                setNotifications(prev => [notification, ...prev]);
            },
            (event) => {
                setNotifications(prev =>
                    prev.map(n =>
                        n.id === event.id ? { ...n, isViewed: true } : n
                    )
                );
            }
        );
        return () => {
            stopNotificationConnection();
        };
    }, []);

    const markAsViewed = async (noti) => {
        try {
            await markNotificationViewed(noti.id).unwrap();
            setOpenNotification(false);

            let encrypted = encrypt("edit");
            const obj = JSON.parse(noti?.link);
            if (obj?.id){
                const url = `/projects/${obj?.projectId}/${obj?.module?.toLowerCase()}-detail/${obj?.id}/${encrypted}/false`;
                window.open(url, "_blank"); // _blank ensures a new tab
            }
            else{
                const url = `/projects/${obj?.projectId}?type=${obj?.module?.toLowerCase()}`;
                localStorage.setItem(`${obj?.module?.toLowerCase()}TabIndex`,obj?.key);
                window.open(url, "_blank"); // _blank ensures a new tab
            }

            
        } catch (err) {
            console.error("Failed to mark notification as viewed:", err);
        }
    };
    const unreadCount = notifications.filter(n => !n.isViewed).length;
    // return (
    //     <div style={{ position: "relative", display: "inline-block" }}>
    //         <button>
    //             🔔
    //             {unreadCount > 0 && (
    //                 <span style={{ color: "red", marginLeft: "4px" }}>
    //                     {unreadCount}
    //                 </span>
    //             )}
    //         </button>
    //         <div style={{
    //             position: "absolute",
    //             top: "100%",
    //             right: 0,
    //             background: "#fff",
    //             border: "1px solid #ccc",
    //             width: "300px",
    //             zIndex: 1000
    //         }}>
    //             {notifications.length === 0 && (
    //                 <div style={{ padding: "8px" }}>No notifications</div>
    //             )}
    //             {notifications.map(notification => (
    //                 <div
    //                     key={notification.id}
    //                     style={{
    //                         padding: "8px",
    //                         background: notification.isViewed ? "#f0f0f0" : "#e6f7ff",
    //                         cursor: "pointer",
    //                         borderBottom: "1px solid #ddd"
    //                     }}
    //                     onClick={() => markAsViewed(notification.id, notification.link)}
    //                 >
    //                     <strong>{notification.title}</strong>
    //                     <div>{notification.message}</div>
    //                     <small>{new Date(notification.createdAt).toLocaleString()}</small>
    //                 </div>
    //             ))}
    //         </div>
    //     </div>
    // );
    return (
        <Popper
            open={open}
            anchorEl={anchorEl}
            placement="bottom-end"
            style={{ zIndex: 1300 }}
            modifiers={[
                {
                    name: "offset",
                    options: {
                        offset: [0, 10],
                    },
                },
            ]}
        >
            <Paper
                elevation={6}
                sx={{
                    width: 360,
                    maxHeight: 400,
                    borderRadius: 3,
                    overflow: "hidden",
                    boxShadow: "0px 4px 20px rgba(0,0,0,0.08)",
                }}
            >
                <Box
                    sx={{
                        position: "sticky",
                        top: 0,
                        backgroundColor: "#fafafa",
                        px: 2,
                        py: 1.5,
                        borderBottom: "1px solid #e0e0e0",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                    }}
                >
                    <NotificationsIcon fontSize="medium" sx={{ color: theme?.customSettings?.themeColor }} />
                    <Typography fontSize="18px" lineHeight="24px" fontWeight={600} color="#252525" >
                        Notifications
                    </Typography>
                </Box>
                <Box
                    sx={{
                        overflowY: "auto",
                        overflowX: "hidden",
                        maxHeight: 360,
                        "&::-webkit-scrollbar": {
                            width: "8px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "#ccc",
                            borderRadius: "8px",
                        },
                    }}
                >
                    <List disablePadding>
                        {notifications.length === 0 ? (
                            <Box
                                sx={{
                                    padding: 2,
                                    textAlign: "center",
                                    color: "#888",
                                    fontSize: "14px",
                                }}
                            >
                                No new notifications
                            </Box>
                        ) : (
                            notifications.map((noti) => (
                                <ListItem
                                    key={noti.id}
                                    sx={{
                                        alignItems: "center",
                                        px: 2,
                                        py: 1.4,
                                        cursor: "pointer",
                                        borderBottom: "1px solid #f0f0f0",
                                        "&:hover": {
                                            backgroundColor: "#f9f9f9"
                                        },
                                    }}
                                    onClick={() => markAsViewed(noti)}
                                >
                                    {/* <ListItemAvatar>
                                    <Avatar
                                        sx={{
                                            bgcolor: noti.read ? "#1976d2" : "#8c8c8c",
                                            width: 36,
                                            height: 36,
                                            fontSize: "14px",
                                        }}
                                    >
                                        ✓
                                    </Avatar>
                                </ListItemAvatar> */}
                                    < ListItemText
                                        primary={
                                            <Typography
                                                fontSize="13px"
                                                lineHeight="20px"
                                                fontWeight={noti.read ? 400 : 600}
                                                color={noti.read ? "#696969" : "#252525"}
                                            >
                                                {noti.title} 
                                            </Typography>
                                        }
                                        secondary={
                                            <>
                                                <Typography
                                                fontSize="11px"
                                                lineHeight="18px"
                                                fontWeight={500}
                                                color="#696969"
                                                >
                                                {noti.message}
                                                </Typography>
                                                <Typography
                                                    fontSize="11px"
                                                    lineHeight="18px"
                                                    fontWeight={500}
                                                    color="#696969"
                                                >
                                                    {moment(noti.createdAt).format("Do MMMM, YYYY")}
                                                </Typography>
                                            </>
                                        }
                                    />
                                </ListItem>
                            ))
                        )}
                    </List>
                </Box>
            </Paper>
        </Popper >
    );
}
